import { useCallback } from 'react';
import { confirmDialog } from 'primereact/confirmdialog';

export const useConfirmation = () => {
  const confirm = useCallback((options) => {
    confirmDialog(options);
  }, []);

  return { confirm };
};